.nav {
  background: var(--white);
  border-bottom: 1px solid var(--border);
  height: 68px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 8px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Google Sans', sans-serif;
  font-size: 19px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -.01em;
  text-decoration: none;
}

.logoIcon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logoIcon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.spacer { flex: 1; }

.tabs { display: flex; gap: 2px; }

.tab {
  padding: 9px 18px;
  border-radius: 20px;
  font-size: 14.5px;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
  transition: background .15s, color .15s;
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}

.tab:hover { background: var(--bg); color: var(--ink); }
.tab.active { background: var(--blue-lt); color: var(--blue); }

.divider {
  width: 1px;
  height: 28px;
  background: var(--border);
  margin: 0 8px;
}

.avatarWrap {
  position: relative;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--blue);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Google Sans', sans-serif;
  letter-spacing: .02em;
  transition: box-shadow .15s;
  user-select: none;
}

.avatar:hover {
  box-shadow: 0 0 0 3px var(--blue-lt);
}

/* Dropdown menu */
.menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: white;
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-lg);
  min-width: 220px;
  z-index: 200;
  overflow: hidden;
  animation: slideIn .15s ease;
}

.menuHeader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
}

.menuAvatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--blue-lt);
  color: var(--blue);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  flex-shrink: 0;
}

.menuName {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
}

.menuSub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 1px;
}

.menuDivider {
  border: none;
  border-top: 1px solid var(--border);
  margin: 0;
}

.menuItem {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px 16px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 500;
  color: var(--ink2);
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  transition: background .1s;
  text-align: left;
}

.menuItem:hover {
  background: var(--bg);
  color: var(--ink);
}
